module.exports = __webpack_public_path__ + "img/topvideoshoujimob.3056890e.png";